import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const Button = styled.button`
  width: ${props => (props.width ? props.width : '120px')};

  height: ${props => (props.height ? props.height : '40px')};
  line-height: ${props => (props.height ? props.height : '40px')};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(90deg, rgba(239, 184, 11, 1) 0%, rgba(251, 218, 60, 1) 100%);
  border-radius: 3px;
  cursor: pointer;
  color: #212833;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: none;
  outline: none;
  box-sizing: border-box;
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(circle, #999 10%, transparent 10.01%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform 0.3s, opacity 0.5s;
  }
  &:active:after {
    transform: scale(0, 0);
    opacity: 0.6;
    transition: 0s;
  }
  span {
    transition: transform 0.2s ease;
    white-space: nowrap;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  a {
    transition: transform 0.2s ease;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  i {
    @media (max-width: 768px) {
      display: none;
    }
  }
  &:hover span {
    transform: scale(0.9);
  }
  &:hover a {
    transform: scale(0.9);
  }
  &:hover i {
    transform: scale(0.9);
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`

const DisabledButton = styled(Button)`
  background: #848e9c;
  color: #fff;
  box-shadow: none;
  width: ${props => (props.width ? props.width : '100px')};
  &:hover {
    transform: scale(1);
  }
`

const Loading = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #fff;
  border-left: 1px solid transparent;
  animation: load 0.8s infinite linear;
  align-self: center;
  @keyframes load {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default class ButtonDiv extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    width: PropTypes.string,
    height: PropTypes.string,
    children: PropTypes.element,
    id: PropTypes.string,
  }

  static defaultProps = {
    disabled: false,
    loading: false,
    onClick: () => {},
    children: null,
    width: '',
    height: '',
    type: 'active',
    id: '',
  }

  _handleClick = ev => {
    const { onClick, loading } = this.props
    if (loading) {
      return
    }
    onClick && onClick(ev)
  }

  render() {
    const { disabled, children, loading, width, height, id } = this.props
    return (
      <Fragment>
        {!disabled ? (
          <Button onClick={this._handleClick} width={width} height={height} id={id}>
            {loading ? <Loading /> : children}
          </Button>
        ) : (
          <DisabledButton width={width} height={height} id={id}>
            {children}
          </DisabledButton>
        )}
      </Fragment>
    )
  }
}
